import { render, staticRenderFns } from "./ManualCombineResultCard.vue?vue&type=template&id=df2418da"
import script from "./ManualCombineResultCard.vue?vue&type=script&lang=ts"
export * from "./ManualCombineResultCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports